import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { GeneralInformation } from '../../domain/interfaces/general-information';
import { getData } from '../../domain/utils/get-data';
import supabase from '../../../core/supabase/supabase';

const PREFIX = 'gameInfo';

export const resetGameInfo = createAction(`${PREFIX}/resetGameInfo`);

export const syncGameInfo = createAsyncThunk<GeneralInformation, { matchId: number }>(
  `${PREFIX}/syncData`,
  async (payload, { rejectWithValue }) => {
    try {
      return await getData(payload.matchId);
    } catch (error) {
      console.error(`${PREFIX}/fetchUser error:`, error);

      let message;
      if ('message' in (error as Error)) message = (error as Error)?.message;
      else message = String(error);

      supabase.overlayLogs.createError({ comment: 'Не удалось получить данные при синхронизации', message });

      return rejectWithValue(message);
    }
  },
);

export const fetchPassedEvents = createAsyncThunk<number[], { matchId: number }>(
  `${PREFIX}/fetchEvents`,
  async (payload, { rejectWithValue }) => {
    try {
      const data = await supabase.matchChronology.getRow(payload.matchId);
      return data?.chronology.map((event) => event.id) ?? [];
    } catch (error) {
      console.error(`${PREFIX}/fetchEvents error:`, error);

      let message;
      if (error instanceof Error) message = error.message;
      else message = String(error);
      return rejectWithValue(message);
    }
  },
);
